<template>
  <heatmap-chart
    :color="color"
    :title="direction === 'outbound' ? 'Outbound heatmap' : 'Voice heatmap'"
    :data="data"
    :xAxis="xAxis"
    :yAxis="yAxis"
    :min="min"
    :max="max"
    type="voice"
  />
</template>
<script>
import apiDashboard from '@/apis/dashboard'

import HeatmapChart from '@/components/echart/heatmap'

export default {
  components: {
    HeatmapChart
  },
  props: {
    clear: Number,
    refresh: Object,
    from: String,
    to: String,
    direction: String
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? [
              this.$getVoiceOutboundColor[
                this.$getVoiceOutboundColor.length - 2
              ],
              this.$getVoiceOutboundColor[0]
            ]
          : [
              this.$getVoiceColor[this.$getVoiceColor.length - 2],
              this.$getVoiceColor[0]
            ],
      min: 0,
      max: 0,
      data: [],
      xAxis: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
      ],
      yAxis: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    }
  },
  watch: {
    clear: {
      handler(val) {
        if (val) this.data = []
      }
    },
    'refresh.count': {
      immediate: true,
      handler(val) {
        this.getVoiceHourly()
      }
    }
  },
  methods: {
    async getVoiceHourly() {
      this.data = []

      try {
        const obj = {
          from: this.from,
          to: this.to,
          direction: this.direction
        }
        const result = await apiDashboard.getVoiceHourly(obj)
        const { min, max, data } = result.data
        this.min = min
        this.max = max
        this.data = data.map(function(item) {
          return [item[1], item[0], item[2] || '-']
        })
      } catch {}
    }
  }
}
</script>
